// extracted by mini-css-extract-plugin
export default {"goToTopButton":"Gototop_goToTopButton__TqizY","visible":"Gototop_visible__EI3b6","hidden":"Gototop_hidden__0au9f"};